import { Button, formatBytes } from '@fountain/fountain-ui-components';
import {
  CheckOutlineIcon,
  Icon,
  TrashOutlineIcon,
  UploadOutlineIcon,
} from '@fountain/ripple/icon';
import { Grid, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { deleteApplicantsUpload } from 'containers/ApplicantsImportModal/actions';
import { iconLabels } from 'shared/iconLabels';

import useStyles from './styles';

// TODO:: circular loader
const FilePreview = props => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { formatMessage } = useIntl();

  const removeUploadedFile = () => {
    dispatch(deleteApplicantsUpload());
    props.fileWithMeta.remove();
  };

  const cancelUpload = () => {
    props.fileWithMeta.cancel();
  };

  const { name, percent, previewUrl, size, status } = props.meta;

  return (
    <>
      {status === 'done' ? (
        <Grid
          container
          direction="column"
          alignItems="center"
          className={classes.previewContainer}
        >
          {previewUrl && (
            <img
              src={previewUrl}
              alt="file preview"
              className={classes.filePreview}
            />
          )}
          <Grid container justify="space-between" alignItems="center">
            <Grid className={classes.previewDetails} title={name}>
              <span className={classes.previewIconContainer}>
                <Icon icon={CheckOutlineIcon} size="xs" color="white" />
              </span>
              <Typography
                variant="body2"
                className={classes.fileName}
                display="inline"
                noWrap
              >
                {name}&nbsp;
              </Typography>
              <Typography variant="body2" display="inline">
                {formatBytes(size)}
              </Typography>
            </Grid>
            <button
              className={classes.deleteButton}
              type="button"
              onClick={removeUploadedFile}
              aria-label={formatMessage(iconLabels.delete)}
            >
              <Icon icon={TrashOutlineIcon} size="sm" />
            </button>
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          direction="column"
          alignItems="center"
          className={classes.previewContainer}
        >
          <div className={classes.uploadContainer}>
            <div className={classes.uploadInnerContainer}>
              <Icon icon={UploadOutlineIcon} size="sm" color="blue" />
            </div>
          </div>
          <Typography color="primary">Uploading ({percent}%)</Typography>
          <Grid container alignItems="center" justify="center">
            <Typography variant="body2">
              {name} ({formatBytes(size * percent)}/{formatBytes(size)})&nbsp;
            </Typography>
            <Button type="text" onClick={cancelUpload} autoWidth>
              Cancel &times;
            </Button>
          </Grid>
        </Grid>
      )}
    </>
  );
};

FilePreview.propTypes = {
  fileWithMeta: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
};

export default FilePreview;
